import BossModel from "@/models/BossModel";
import Country from "@/models/Country/Country";
import WebsiteCategory from "@/models/WebsiteCategory/WebsiteCategory";
import WebsiteRoute from "@/models/WebsiteRoute/WebsiteRoute";
import Region from "@/models/Region/Region";
import Container from "@/models/WebsitePage/Version/Container/Container.js";

export default class WebsiteFilterPage extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'website-filter-page';

    /**
     *
     * @type {string}
     */
    static entity = 'websiteFilterPages';

    static fields() {
		return {
			id: this.number(null).nullable(),
			title: this.attr(null),
			intro_text: this.attr(null),
			meta_title: this.attr(null),
			meta_description: this.attr(null),
			website_category_id: this.number(null).nullable(),
			country_id: this.number(null).nullable(),
			created_at: this.attr(null),
			updated_at: this.attr(null),
			region_id: this.number(null).nullable(),
			is_hotels: this.boolean(null),
            is_show_inspiration: this.boolean(null),
            websiteCategory: this.belongsTo(WebsiteCategory, 'website_category_id'),
            country: this.belongsTo(Country, 'country_id'),
            region: this.belongsTo(Region, 'region_id'),
            websiteRoute: this.hasOne(WebsiteRoute, 'routeable_id'),
            containers: this.hasMany(Container, 'website_filter_page_id'),
		}
	}

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    Country() {
        return this.getRelated('country');
    }

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    WebsiteCategory() {
        return this.getRelated('websiteCategory');
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    WebsiteRoute() {
        return WebsiteRoute.findByRouteable(this.id, 'website_filter_page');
    }
}
